import { GameVariant, Move, Piece, PieceType } from '@draughts/shared';
import { promotionHopInPassing } from '@draughts/core';

/**
 * IL FANTASMA DELLA PRESA: lo stesso pezzo, con la corona se l'ha gia' presa.
 *
 * Tre posti disegnano un fantasma — la presa che stiamo facendo, quella che stiamo
 * subendo, e il pezzo in mano a meta' presa — e tutti e tre leggono il pezzo
 * nell'istantanea di PRIMA della mossa, dove la pedina e' ancora pedina. Deve essere
 * cosi': la damiera viva, durante una presa altrui, ha gia' portato il pezzo in fondo.
 * Il prezzo era che nella Russa la corona compariva solo all'ultimo fotogramma, mentre
 * la regola la da' a meta' strada (vedi `promotionHopInPassing`): si vedeva una pedina
 * fare un salto da dama.
 *
 * `<Piece>` non ha un prop «e' dama»: la dama e' `piece.type === KING`, e tutto il resto
 * — emblema, corona, materiale — `Piece` lo legge da se' dalle preferenze. Quindi basta
 * ribaltare il tipo.
 *
 * Senza corona si restituisce LO STESSO OGGETTO, non una copia: `Piece` e' `memo`, e un
 * oggetto nuovo a ogni render lo farebbe ridisegnare per niente.
 *
 * Fuori dalla promozione al volo `promotionHopInPassing` tace sempre, quindi qui non
 * serve nessun elenco di varianti: su tutte le altre il fantasma resta pedina per tutto
 * il cammino, ed e' esattamente la regola (l'Internazionale e la Turca attraversano
 * l'ultima traversa senza coronare).
 */
export function ghostPiece(
  piece: Piece,
  /** La presa in corso. Le candidate concordano sui salti gia' percorsi: ne basta una. */
  move: Pick<Move, 'path' | 'to'> | undefined,
  /** Quanti salti sono gia' a schermo: il fantasma sta sul salto `hopsDrawn - 1`. */
  hopsDrawn: number,
  variant: GameVariant,
): Piece {
  if (!move) return piece;
  const corona = promotionHopInPassing(move, piece, variant);
  if (corona === null || corona > hopsDrawn - 1) return piece;
  return { ...piece, type: PieceType.KING };
}
